const ProgressLine = ({ value = 0, width = 120, height = 8, condition }) => {
  const utilization = Math.round(value); // nearest %
  const barWidth = Math.min(utilization, 100) / 100 * width;

  // Decide color class
  const colorClass = condition
    ? condition
    : utilization == 100
    ? "fill-green-400 text-green-600"
    : utilization == 75 ? "fill-yellow-400 text-yellow-600" : utilization == 50 ? "fill-orange-400 text-orange-600" : "fill-red-400 text-red-600";

    // fill-red-400 text-red-400

  return (
    <div>
      <div className="flex items-center justify-between">
        <svg width={width} height={height} className="rounded-full overflow-hidden">
          {/* Background */}
          <rect
            width={width}
            height={height}
            rx={height / 2}
            ry={height / 2}
            className="fill-gray-200"
          />
          {/* Progress */}
          <rect
            width={barWidth}
            height={height}
            rx={height / 2}
            ry={height / 2}
            className={`transition-all duration-500 ease-in-out ${colorClass.split(" ")[0]}`}
          />
        </svg>

        {/* Percentage text */}
        <span className={`ml-2 text-xs font-semibold font-number ${colorClass.split(" ")[1]}`}>
          {utilization}%
        </span>
      </div>
    </div>
  );
};

export default ProgressLine;